import { captureException } from "@sentry/nextjs";

export async function fetchLPInfo(): Promise<
  | {
      lpApy: number;
      lpApyDay: number;
      lpApyWeek: number;
      lpPrice: number;
    }
  | undefined
> {
  try {
    const responseApyDay = await fetch(
      "https://api.marinade.finance/lp/apy/1d"
    );
    if (!responseApyDay.ok) {
      throw new Error(
        `${responseApyDay.statusText} /// ${responseApyDay.status}`
      );
    }

    const responseApyWeek = await fetch(
      "https://api.marinade.finance/lp/apy/1w"
    );
    if (!responseApyWeek.ok) {
      throw new Error(
        `${responseApyWeek.statusText} /// ${responseApyWeek.status}`
      );
    }

    const responseApyMonth = await fetch(
      "https://api.marinade.finance/lp/apy/30d"
    );
    if (!responseApyMonth.ok) {
      throw new Error(
        `${responseApyMonth.statusText} /// ${responseApyMonth.status}`
      );
    }

    const responsePrice = await fetch("https://api.marinade.finance/lp/price");
    if (!responsePrice.ok) {
      throw new Error(responsePrice.statusText);
    }

    const resultApyDay = await responseApyDay.json();
    const resultApyWeek = await responseApyWeek.json();
    const resultApyMonth = await responseApyMonth.json();
    const resultPrice = await responsePrice.json();
    return {
      lpApy: resultApyMonth.value,
      lpApyDay: resultApyDay.value,
      lpApyWeek: resultApyWeek.value,
      lpPrice: resultPrice,
    };
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
